<div
  class="row m-0"
  dropFile
  (files)="fileUploadModalService.filesDropped($event)"
  (contextmenu)="onContextMenu($event)"
  >
  <div class="col-md-3">
    <div
      class="card bg-transparent border-0 shadow mt-3 p-3"
      style="min-height: 90vh"
      >
      <div class="card bg-transparent border-0">
        <div class="my-4 mt-1">
          @if (version) {
            <span
              class="badge bg-primary text-dark float-end clickable rounded-pill"
              style="user-select: none"
              (click)="openLogViewer()"
              >Version {{ version }}
            </span>
          }
        </div>
        <div class="card-body p-1 py-0">
          <div class="d-flex">
            <img style="height: 33px" src="assets/folder.svg" alt="" />
            <h1 class="ms-3">Droplet</h1>
          </div>
        </div>
      </div>
      <button
        class="btn btn-sm btn-warning me-2 w-100 mt-1 text-start text-dark"
        routerLink="uploads_sr"
        [hidden]="!('SR' | auth)"
        >
        Student Records
      </button>
      <button
        class="btn btn-sm btn-primary me-2 w-100 mt-2 text-start text-dark"
        routerLink="uploads_sped"
        [hidden]="!('SPED' | auth)"
        >
        Special Education Records
      </button>
      <button
        class="btn btn-sm btn-success me-2 w-100 mt-2 text-start text-dark"
        routerLink="uploads_er"
        [hidden]="!('HR' | auth)"
        >
        Employee Records
      </button>
      <button
        class="btn btn-sm btn-info me-2 w-100 mt-2 text-start text-dark"
        routerLink="uploads_ar"
        [hidden]="!('AR' | auth)"
        >
        Administrative Records
      </button>

      <div class="card bg-transparent border-0 mt-4">
        <div class="card-body p-1">
          <div class="d-flex">
            <img style="height: 33px" src="assets/printer.svg" alt="" />
            <h2 class="ms-3">Virtual Printer</h2>
          </div>
        </div>
      </div>

      <button
        class="btn btn-sm btn-dark me-2 w-100 text-start"
        routerLink="uploads_all"
        >
        Recently Printed Document
      </button>
      <div class="card bg-transparent border-0 mt-4">
        <div class="card-body p-0">
          <div class="d-flex pb-2">
            <img style="height: 45px" src="assets/YFHNT.svg" alt="" />
          </div>
          <button
            class="btn btn-sm btn-warning me-2 w-100 mt-2 text-dark text-start btn-hover"
            (click)="searchRecord()"
            >
            Search Records in Browser
          </button>
          @if (isElectron()) {
            <button
              class="btn btn-sm btn-warning me-2 w-100 mt-1 text-dark text-start btn-hover"
              [disabled]="downloadProgress.status === DownloadStatus.DOWNLOADING"
              >
              @switch (downloadProgress.status) {
                @case (DownloadStatus.NOT_STARTED) {
                  <span>
                    Checking for Updates...
                  </span>
                }
                @case (DownloadStatus.DOWNLOADING) {
                  <span>
                    Downloading: {{ downloadProgress.progress }}%
                  </span>
                }
                @case (DownloadStatus.COMPLETED) {
                  <span (click)="restartApp()" style="cursor: pointer;">
                    Download Complete - Click to Restart
                  </span>
                }
                @case (DownloadStatus.ERROR) {
                  <span (click)="checkForUpdates()" style="cursor: pointer;">
                    Up to Date
                  </span>
                }
                @case (DownloadStatus.NOT_AVAILABLE) {
                  <span (click)="checkForUpdates()" style="cursor: pointer;">
                    Up to Date
                  </span>
                }
              }
            </button>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-9 ps-1">
    <router-outlet></router-outlet>
  </div>
</div>
